module.exports = __webpack_public_path__ + "static/media/hero-3.915f6fa0.jpg";